import { parseNovelAdminMediaList } from '@drama/contracts/novel'

import { novelAdminHttp } from './http.js'

const QUERY_KEYS = new Set(['kind', 'pack_id', 'run_id', 'user_id', 'limit', 'offset'])
const MEDIA_KINDS = new Set(['speech', 'opening_speech', 'drama_video'])

/**
 * @callchain.routeId novel.admin.media.list
 * @param {{ kind?: string, pack_id?: string, run_id?: string, user_id?: string, limit?: number, offset?: number }} [query]
 */
export async function listNovelMedia(query = {}) {
  const unknown = Object.keys(query).filter(key => !QUERY_KEYS.has(key))
  if (unknown.length > 0) throw new Error(`listNovelMedia: unknown query keys ${unknown.join(', ')}`)
  const result = await novelAdminHttp().get('/media', { query, routeId: 'novel.admin.media.list' })
  return parseNovelAdminMediaList(result)
}

/**
 * 复用后台的令牌刷新和鉴权出口；播放器只接本地 Blob URL。
 * @callchain.routeId novel.admin.media.content
 * @param {'speech'|'opening_speech'|'drama_video'} kind
 * @param {string} asset_id
 * @returns {Promise<Blob>}
 */
export async function getNovelMediaContent(kind, asset_id) {
  if (!MEDIA_KINDS.has(kind) || !/^[a-f0-9]{64}$/.test(asset_id)) throw new Error('invalid_media_identity')
  const content = await novelAdminHttp().getBlob(`/media/${kind}/${encodeURIComponent(asset_id)}/content`, {
    routeId: 'novel.admin.media.content',
  })
  const expected_type = kind === 'drama_video' ? 'video/' : 'audio/'
  if (content.size === 0 || !content.type.toLowerCase().startsWith(expected_type)) throw new Error('invalid_media_content')
  return content
}
